import React from "react";
import { FormControl, FormLabel, MenuItem, Select } from "@mui/material";
import { Controller, FieldValues } from "react-hook-form";

interface AGSelectProps {
  name: string;
  label?: string;
  control: any;
  options: { label: string; value: string }[];
  error?: string;
  rules?: Partial<FieldValues>; // Validation rules
  required?: boolean;
  onChange?: (e: any) => void;
  value?: any;
  disabled?: boolean;
  multiple?: boolean;
}

const AGSelect: React.FC<AGSelectProps> = ({
  name,
  label,
  control,
  options,
  error,
  rules,
  required = false,
  onChange,
  disabled = false,
  value,
  multiple = false,
}) => {
  return (
    <FormControl error={!!error} fullWidth margin="normal" size="small">
      {label && (
        <FormLabel className=" mb-1 font-semibold text-black text-sm">
          {label}
        </FormLabel>
      )}{" "}
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => (
          <Select
            {...field}
            fullWidth
            disabled={disabled}
            required={required}
            value={field.value ?? value}
            variant="outlined"
            error={!!error}
            multiple={multiple}
            onChange={(e) => {
              field.onChange(e);
              onChange && onChange(e);
            }}
          >
            <MenuItem disabled value={""}>
              Select
            </MenuItem>
            {options.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        )}
      />
    </FormControl>
  );
};

export default AGSelect;
